import type {PullRequestFileTreeDiff} from '../page-data/payloads/file-tree'

type DiffSummary = PullRequestFileTreeDiff | Pick<PullRequestFileTreeDiff, 'path' | 'markersMap'>

export function contextRangesForMarkers({
  paths,
  diffSummaries,
}: {
  paths: Set<string>
  diffSummaries: {[path: string]: DiffSummary}
}): {[path: string]: Array<[number, number]>} {
  const contextRanges: Record<string, Array<[number, number]>> = {}

  for (const path of paths) {
    const summary = diffSummaries[path]

    if (summary && !!summary.markersMap) {
      const rangesForPath: Array<[number, number]> = []

      for (const position in summary.markersMap) {
        const ctx = summary.markersMap[position]?.ctx
        if (ctx) {
          rangesForPath.push(ctx)
        }
      }

      contextRanges[path] = rangesForPath
    }
  }

  return contextRanges
}
